import React from "react";
import { Card, CardBody, Col, FormGroup, Input, Label, Row } from "reactstrap";
import SectionHeader from "@dhn/components/molecules/section-header";
import SelectableOption from "@dhn/components/molecules/selectable-option";

const TERMS_URL = "/legal-documents/terminos-uso-dhn-consultorios.pdf";
const PRIVACY_URL = "/legal-documents/politica-privacidad-dhn.pdf";
const DOCUMENT_PAGES = {
  [TERMS_URL]: [
    "/legal-documents/rendered/terminos-uso-dhn-consultorios-1.png",
    "/legal-documents/rendered/terminos-uso-dhn-consultorios-2.png",
    "/legal-documents/rendered/terminos-uso-dhn-consultorios-3.png",
  ],
  [PRIVACY_URL]: [
    "/legal-documents/rendered/politica-privacidad-dhn-1.png",
    "/legal-documents/rendered/politica-privacidad-dhn-2.png",
    "/legal-documents/rendered/politica-privacidad-dhn-3.png",
  ],
};

const LegalDocumentViewer = ({ title, description, url, children }) => {
  const pages = DOCUMENT_PAGES[url] || [];

  return (
    <Card className="mt-3">
      <CardBody>
        <SectionHeader
          compact
          icon="fa-file-text-o"
          title={title}
          description={description}
        />
        <div className="legal-document-viewer" onContextMenu={(event) => event.preventDefault()}>
          {pages.map((pageUrl, index) => (
            <div className="legal-document-page" key={pageUrl}>
              <div className="legal-page-count">
                Página {index + 1} de {pages.length}
              </div>
              <img
                src={pageUrl}
                alt={`${title} - página ${index + 1}`}
                draggable={false}
                loading="lazy"
              />
            </div>
          ))}
          {!pages.length && (
            <div className="legal-document-unavailable">
              No fue posible mostrar el documento legal.
            </div>
          )}
        </div>
        {children}
      </CardBody>
    </Card>
  );
};

const LegalRequirementsStep = ({
  canShowLegalRequirements,
  documentsLength,
  requiredDocumentsCount,
  legalDocument,
  form,
  onChange,
  showInlineError,
}) => {
  if (!canShowLegalRequirements) {
    return (
      <div className="legal-gate-note fade-in-up">
        {!documentsLength
          ? requiredDocumentsCount
            ? `Adjunte ${requiredDocumentsCount} ${requiredDocumentsCount === 1 ? "archivo" : "archivos"
            }, uno por cada documento requerido, para habilitar Requerimientos Legales.`
            : "Adjunte al menos un documento para habilitar Requerimientos Legales."
          : requiredDocumentsCount && documentsLength !== requiredDocumentsCount
            ? `Debe adjuntar ${requiredDocumentsCount} ${requiredDocumentsCount === 1 ? "archivo" : "archivos"
            } en total para habilitar Requerimientos Legales.`
            : "Marque el checklist de documentos para habilitar Requerimientos Legales."}
      </div>
    );
  }

  return (
    <>
      <div className="prereg-step-header">
        <span className="prereg-step-index">Paso 4</span>
        <h6>Requerimientos Legales</h6>
      </div>

      <Card className="fade-in-up mb-3">
        <CardBody>
          <SectionHeader icon="fa-gavel" title="Requerimientos Legales" />

          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Documento</Label>
                <Input
                  value={legalDocument}
                  readOnly
                  placeholder="Se llena con el formulario"
                />
              </FormGroup>
            </Col>
          </Row>

          <LegalDocumentViewer
            title="Términos y Condiciones de Uso"
            description="Revise los términos antes de aprobar esta solicitud."
            url={TERMS_URL}
          >
            <SelectableOption
              className="mt-3"
              icon="fa-check-square-o"
              title="Leído y aprobado."
              description="Términos y Condiciones de Uso"
              inputName="termsAccepted"
              id="prereg-terms-accepted"
              checked={form.termsAccepted}
              onChange={(event) => onChange("termsAccepted", event.target.checked)}
            />
          </LegalDocumentViewer>

          <LegalDocumentViewer
            title="Política de Privacidad"
            description="Revise cómo DHN trata y protege sus datos personales."
            url={PRIVACY_URL}
          >
            <SelectableOption
              className="mt-3"
              icon="fa-shield"
              title="Leído y aprobado."
              description="Política de Privacidad"
              inputName="privacyAccepted"
              id="prereg-privacy-accepted"
              checked={form.privacyAccepted}
              onChange={(event) => onChange("privacyAccepted", event.target.checked)}
            />
          </LegalDocumentViewer>
          {showInlineError("legalChecks")}
        </CardBody>
      </Card>
    </>
  );
};

export default LegalRequirementsStep;
